<template>
  <div>
    <div class="desktop-nav" :style="{
      opacity,
      transform
    }">
        <Nav/>
    </div>
  </div>
</template>

<script>
import Nav from '@/components/Nav.vue'
import pageLoadAnimationBus from '../pageLoadAnimationBus'
export default {
  components: {
    Nav
  },
  data () {
    return {
      opacity: 1,
      translateY: 0
    }
  },
  computed: {
    transform () { return 'translateY(' + (this.translateY).toString() + 'px)' }
  },
  mounted () {
    pageLoadAnimationBus.registerComponent('nav', this)
  }
}
</script>

<style lang="scss">
.desktop-nav{
  z-index: 10000;
  display: flex;
  // flex-direction: row;
  align-items: center;
  position: absolute;
  right: 2vw;
  top: 0;
  height: 100px;
  // background-color: gray;

  .navItem{
      margin: 0px 0px;
      font-size: 20px;
  }

}

</style>
